export { ReactComponent as MynewsdeskLogoInverted } from '../svg/mynewsdesk-logo-inverted.svg';
export { ReactComponent as MynewsdeskLogo } from '../svg/mynewsdesk-logo.svg';
